import React from 'react';
import { Box, Stack, Typography, alpha } from '@mui/material';
import { getAccentColor, getBodyColor } from './shared';

const ProfileCardsSection = ({
  section, sectionKey, sectionIndex, profiles, columns, profileImageObjectPosition, emptyMessage,
  renderHtmlTextBlock, renderPositionableElement,
}) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const bodyColor = getBodyColor(section) || '#64748B';
  const safeColumns = Math.max(1, Math.min(columns || 3, 4));

  return (
    <Box component="section" sx={{ py: { xs: 1, md: 1.6 } }}>
      <Stack spacing={4} sx={{ width: '100%' }}>
        {(section.title || section.body) && (
          <Stack spacing={1.5} sx={{ textAlign: section.textAlign || 'left', mb: 2 }}>
            {section.title && <Typography component="h2" sx={{ color: '#0F172A', fontWeight: 800, fontSize: { xs: '2rem', md: '2.5rem' }, letterSpacing: '-0.02em', lineHeight: 1.1 }}>{section.title}</Typography>}
            {section.body && renderPositionableElement({ section, index: sectionIndex, elementKey: `${sectionKey}-intro`, children: renderHtmlTextBlock(section.body, { color: bodyColor, lineHeight: 1.7, fontSize: '1.1rem' }) })}
          </Stack>
        )}
        
        {profiles.length ? (
          <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr', sm: `repeat(${Math.min(2, safeColumns)}, 1fr)`, md: `repeat(${safeColumns}, 1fr)` } }}>
            {profiles.map((profile, index) => (
              <Box key={`${sectionKey}-profile-${index}`}>
                {renderPositionableElement({
                  section, index: sectionIndex, elementKey: `${sectionKey}-profile-${index}`,
                  children: (
                    <Box sx={{ height: '100%', p: 3, borderRadius: '32px', backgroundColor: alpha(accent, 0.03), border: `1px solid ${alpha(accent, 0.08)}`, transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-6px)', backgroundColor: alpha(accent, 0.05) } }}>
                      <Stack spacing={2} alignItems="center" textAlign="center">
                        {profile.image && (
                          <Box sx={{ width: 140, height: 140, borderRadius: '50%', overflow: 'hidden', border: `4px solid #FFFFFF`, boxShadow: `0 8px 24px ${alpha('#0F172A', 0.1)}` }}>
                            <Box component="img" src={profile.image} alt={profile.name || ''} sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: profileImageObjectPosition || 'center' }} />
                          </Box>
                        )}
                        <Box>
                          {profile.role && <Typography sx={{ color: accent, fontWeight: 700, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 0.5 }}>{profile.role}</Typography>}
                          <Typography sx={{ color: '#0F172A', fontWeight: 800, fontSize: '1.25rem', mb: 1 }}>{profile.name || ''}</Typography>
                          {profile.bio && <Typography sx={{ color: '#475569', fontSize: '0.95rem', lineHeight: 1.6 }}>{profile.bio}</Typography>}
                        </Box>
                      </Stack>
                    </Box>
                  ),
                })}
              </Box>
            ))}
          </Box>
        ) : (
          <Typography sx={{ color: bodyColor, fontSize: '1rem', textAlign: 'center', py: 4 }}>{emptyMessage}</Typography>
        )}
      </Stack>
    </Box>
  );
};
export default ProfileCardsSection;
